import { useSuspenseQuery } from '@tanstack/react-query';

import { getPresentationValidationHistoryOptions } from '@/module/Author/Presentation/Validation/model/PresentationValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface PresentationValidationHistoryProps {
  presentationId: Id;
}

export function PresentationValidationHistory({ presentationId }: PresentationValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getPresentationValidationHistoryOptions(presentationId));

  return <ValidationHistoryContent history={history} />;
}
